import { render, staticRenderFns } from "./MothersDay.vue?vue&type=template&id=0b454d9b&"
import script from "./MothersDay.vue?vue&type=script&lang=js&"
export * from "./MothersDay.vue?vue&type=script&lang=js&"
import style0 from "./MothersDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports